import { PROVIDER_SOURCE } from '../../constants/quote';
import { canSaveRecordPolicy, policyIsCurrentActiveRenewPolicy } from '../../flagJudgement/policy';
import { PolicyStatus } from '../../shared/generated';
export var usePolicyDetailInfo = function usePolicyDetailInfo() {
  /**
   * methods
   */
  var canCreateRecordPolicy = function canCreateRecordPolicy(policyInfo) {
    var _ref = policyInfo || {},
        canUpdate = _ref.canUpdate,
        status = _ref.status;

    return !!canUpdate || [PolicyStatus.POLICY_RENEWED_UPDATE_SUBMITTED].includes(status);
  };

  var canUpdatePolicy = function canUpdatePolicy(policyInfo) {
    var _ref2 = policyInfo || {},
        status = _ref2.status;

    return [PolicyStatus.POLICY_RENEWED_INITIATED, PolicyStatus.POLICY_UPDATE_QUOTE, PolicyStatus.POLICY_UPDATE_INITIATED, PolicyStatus.POLICY_RENEWED_UPDATE_QUOTE, PolicyStatus.POLICY_UPDATE_INITIATED].includes(status);
  };

  var canSendPolicyEmail = function canSendPolicyEmail(policyInfo) {
    var _ref3 = policyInfo || {},
        status = _ref3.status;

    return [PolicyStatus.POLICY_RENEWED_INITIATED, PolicyStatus.POLICY_RENEWED_UPDATE_QUOTE, PolicyStatus.POLICY_RENEWED_UPDATE_REFERRAL, PolicyStatus.POLICY_RENEWED_UPDATE_SUBMITTED, PolicyStatus.POLICY_UPDATED, PolicyStatus.POLICY_UPDATE_QUOTE, PolicyStatus.POLICY_UPDATE_QUOTE_CONFIRMED, PolicyStatus.POLICY_UPDATE_REFERRAL].includes(status);
  };

  var canCalculatePrice = function canCalculatePrice(policyInfo) {
    return canSaveRecordPolicy(policyInfo);
  };

  var isRenewPolicy = function isRenewPolicy(policyInfo) {
    return [PolicyStatus.POLICY_RENEW_TRIGGER, PolicyStatus.POLICY_RENEWED_INITIATED, PolicyStatus.POLICY_RENEWED_UPDATE_SUBMITTED, PolicyStatus.POLICY_RENEWED_UPDATE_REFERRAL, PolicyStatus.POLICY_RENEWED].includes(policyInfo === null || policyInfo === void 0 ? void 0 : policyInfo.status);
  };

  var isCurrentActivePolicy = function isCurrentActivePolicy(policyInfo) {
    return [PolicyStatus.POLICY_RENEW_TRIGGER].includes(policyInfo === null || policyInfo === void 0 ? void 0 : policyInfo.status);
  };

  var canEditPolicyChangeEffectiveDate = function canEditPolicyChangeEffectiveDate(policyInfo) {
    return !policyIsCurrentActiveRenewPolicy(policyInfo);
  };

  var canRevertPolicyToOriginalTerms = function canRevertPolicyToOriginalTerms(policyInfo) {
    var _ref4 = policyInfo || {},
        status = _ref4.status;

    return [PolicyStatus.POLICY_UPDATE_QUOTE, PolicyStatus.POLICY_UPDATE_REFERRAL, PolicyStatus.POLICY_UPDATE_INITIATED, PolicyStatus.POLICY_UPDATE_QUOTE_CONFIRMED].includes(status);
  };

  var canReinstatePolicy = function canReinstatePolicy(policyInfo) {
    var _ref5 = policyInfo || {},
        status = _ref5.status,
        providerCode = _ref5.providerCode;

    return [PolicyStatus.POLICY_CANCELLED].includes(status) && [PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value].includes(providerCode);
  };

  var canUpdatePolicyPremium = function canUpdatePolicyPremium(policyInfo) {
    var _ref6 = policyInfo || {},
        status = _ref6.status,
        providerCode = _ref6.providerCode;

    return [PolicyStatus.POLICY_START].includes(status) && [PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value].includes(providerCode);
  };

  var isCanceledPolicy = function isCanceledPolicy(policyInfo) {
    var _ref7 = policyInfo || {},
        status = _ref7.status;

    return [PolicyStatus.POLICY_CANCELLED].includes(status);
  };

  return {
    canUpdatePolicy: canUpdatePolicy,
    canSendPolicyEmail: canSendPolicyEmail,
    canCalculatePrice: canCalculatePrice,
    isRenewPolicy: isRenewPolicy,
    isCurrentActivePolicy: isCurrentActivePolicy,
    canEditPolicyChangeEffectiveDate: canEditPolicyChangeEffectiveDate,
    canCreateRecordPolicy: canCreateRecordPolicy,
    canRevertPolicyToOriginalTerms: canRevertPolicyToOriginalTerms,
    isCanceledPolicy: isCanceledPolicy,
    canReinstatePolicy: canReinstatePolicy,
    canUpdatePolicyPremium: canUpdatePolicyPremium
  };
};